export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Semester:",
				type: "small",
			},
		],
	},
	{
		type: "special",
		id: 2,
		items: [
			{
				id: 2,
				text: "Field of study:",
				label: [
					{
						id: 1,
						text: "B.Sc. Physik",
					},
					{
						id: 2,
						text: "B.Sc. Biophysik",
					},
					{
						id: 3,
						text: "Physik Lehramt",
					},
					{
						id: 4,
						text: "B.Sc. Quantum Engineering",
					},
					{
						id: 5,
						text: "M.Sc. Physik",
					},
					{
						id: 6,
						text: "SLLS Physik",
					},
					{
						id: 7,
						text: "M.Sc. Biophysik",
					},
					{
						id: 8,
						text: "M.Sc. Quantum Engineering",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 3,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 4,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 5,
				text: "The lecturer has always been well prepared.",
			},
			{
				id: 6,
				text: "The lecturer was very competent.",
			},
			{
				id: 7,
				text: "It was important to the lecturer that the participants benefitted from the course.",
			},
			{
				id: 8,
				text: "The lecturer motivated the participants.",
			},
			{
				id: 9,
				text: "The learning objective was clear to me.",
			},
			{
				id: 10,
				text: "Concerning the organizational aspects of the course (i.e. place, time, performance requirements) I was informed well.",
			},
			{
				id: 11,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 12,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 13,
				text: "The quality of the teaching materials and media was good.",
			},
			{
				id: 14,
				text: "Suggestions for in-depth study were provided (e.g., lecture notes, web links).",
			},
			{
				id: 15,
				text: "The quality of the classroom was good.",
			},
			{
				id: 16,
				text: "The quality of the technical equipment was good.",
			},
			{
				id: 17,
				text: "The topic of the course is relevant for my future professional goals.",
			},
			{
				id: 18,
				text: "The content is illustrative (examples).",
			},
			{
				id: 19,
				text: "The topic was well illustrated by application examples.",
			},
		],
	},
	{
		type: "bi",
		id: 4,
		items: [
			{
				id: 20,
				text: "The difficulty of the content was...",
			},
			{
				id: 21,
				text: "The amount of the content was...",
			},
			{
				id: 22,
				text: "The pace of the course was...",
			},
			{
				id: 23,
				text: "The requirements of the course were...",
			},
			{
				id: 24,
				text: "The amount of time required for the course (including preparation and follow-up) was...",
			},
			{
				id: 25,
				text: "Overall, I felt the course to be...",
			},
		],
	},
	{
		type: "uni",
		id: 5,
		items: [
			{
				id: 26,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 27,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 28,
				text: "The online appointments were well organized.",
			},
			{
				id: 29,
				text: "The online materials (e.g. texts, quizzes, videos, etc.) contributed significantly to the understanding of the learning content.",
			},
			{
				id: 30,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 31,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 32,
				text: "The course is an example of good digital education.",
			},
			{
				id: 33,
				text: "Overall, this was a good course.",
			},
			{
				id: 34,
				text: "I learned a lot in this course.",
			},
			{
				id: 35,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 36,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 6,
		items: [
			{
				id: 37,
				text: "Average time spent on the course in hours per week:",
				type: "small",
			},
			{
				id: 38,
				text: "I especially appreciated:",
			},
			{
				id: 39,
				text: "I did not like:",
			},
			{
				id: 40,
				text: "Suggestions for improvements:",
			},
			{
				id: 41,
				text: "Was there any prior knowledge required that you lacked? If yes, which?",
			},
		],
	},
];
